import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useRef } from "react";
import program_moduleService from "../../../services/program_service/program_module.service";

export const CreateModuleModal: React.FC<any> = ({
  isOpenModule,
  onClosed,
  isModule = false,
  reload
}: {
  isModule: boolean;
  isOpenModule: any;
  onClosed: any;
  reload: any;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const modalSize = useBreakpointValue({ base: "sm", sm: "md", md: "md" , lg:"md" });

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.name) {
        errors.name = "Name is required";
      }
      if (!values.code) {
        errors.code = "Code is required";
      }

      return errors;
    },
    initialValues: {
      name: "",
      code: "",
      description: "",
    },
    onSubmit: async (values) => {
      try {
        const moduleDto: any = {
          name: values.name,
          code: values.code,
          description: values.description,
        };

        const createModule = await program_moduleService.createModule(
          moduleDto
        );
        
        //trying something

        if (createModule) {
          onClosed();
          reload()
          toast({
            title: "Program module",
            description: "module created successfully",
            status: "success",
            duration: 2000,
          });
        }
      } catch (error) {
        toast({
          title: "Program module",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpenModule && isModule}
        onClose={onClosed}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size={modalSize}
      >
        <ModalOverlay />
        <ModalContent borderRadius={5}>
          <ModalHeader>
            {
              <Text
                fontSize={22}
                color="brand.2"
              >
                Create Module
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="md" />
          <ModalBody pb={6}>
            <Box>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  isInvalid={
                    formik.errors.name && formik.touched.name ? true : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                    Module Name
                  </FormLabel>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter name"
                    onChange={formik.handleChange}
                    fontSize={13}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.name}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mt={6}
                  isInvalid={
                    formik.errors.code && formik.touched.code ? true : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                    Module Code
                  </FormLabel>
                  <Input
                    type="text"
                    id="code"
                    name="code"
                    placeholder="Enter Code"
                    onChange={formik.handleChange}
                    fontSize={13}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.code}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  id="description"
                  mt={6}
                  isInvalid={
                    formik.errors.description && formik.touched.description
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                    Description
                  </FormLabel>
                  <Textarea
                    p={4}
                    bg="inputText.500"
                    fontSize={12}
                    size="sm"
                    minH="10rem"
                    placeholder="Enter Description"
                    name="description"
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.description}
                  </FormErrorMessage>
                </FormControl>

                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      size="sm"
                      px={6}
                      fontSize={12}
                      ref={cancelRef}
                      onClick={() => onClosed()}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme="red"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      Confirm
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
